"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataChunkReceipt = void 0;
const zod_1 = require("zod");
/**
 * Based on https://github.com/Irys-xyz/js-sdk/blob/d3f7749c50c47cc2c6ce65aea86705c7a20d5150/src/common/types.ts#L119-L136
 */
exports.DataChunkReceipt = zod_1.z.object({
    id: zod_1.z.string(),
    signature: zod_1.z.string(),
    /**
     * millis since epoch
     */
    timestamp: zod_1.z.number(), // TODO: for now, not using Instant type.
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1jaHVuay1yZWNlaXB0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RhdGEtY2h1bmstcmVjZWlwdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkI7O0dBRUc7QUFDVSxRQUFBLGdCQUFnQixHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUM7SUFDdkMsRUFBRSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUU7SUFDZCxTQUFTLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtJQUNyQjs7T0FFRztJQUNILFNBQVMsRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUseUNBQXlDO0NBQ2pFLENBQUMsQ0FBQSJ9